import { render, staticRenderFns } from "./SelectSiji.vue?vue&type=template&id=f153e4c8&"
import script from "./SelectSiji.vue?vue&type=script&lang=js&"
export * from "./SelectSiji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports